module.exports = __webpack_public_path__ + "static/media/YAC_logo__black.0ed57378.svg";